module.exports = __webpack_public_path__ + "static/media/camera.57422aa9.svg";